import { PERSON_SELECT_NOT_LISTED } from '@wundo/ui';
import { ManagerSelect } from '@/components/team/ManagerSelect.tsx';
import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';
import { m } from '@/paraglide/messages.js';

interface ManagerQuestionProps {
  colleagues: readonly OneOnOneColleagueItem[];
  /** A colleague's id, "not listed", or null while unanswered. */
  value: string | null;
  onValueChange: (value: string | null) => void;
}

/** "Who is your manager?", asked once along the way and never required. */
export function ManagerQuestion({
  colleagues,
  value,
  onValueChange,
}: ManagerQuestionProps) {
  return (
    <div className='mt-6 flex flex-col gap-2.5 border-t border-fill pt-5'>
      <div className='flex flex-col gap-1'>
        <p className='flex items-baseline gap-2 text-base font-bold text-ink'>
          {m.manager_question_title()}
          <span className='text-sm font-medium text-ink-muted'>
            {m.manager_question_optional()}
          </span>
        </p>
        <p className='text-sm text-ink-muted'>
          {m.manager_question_onboarding_explanation()}
        </p>
      </div>
      <ManagerSelect
        colleagues={colleagues}
        value={value}
        onValueChange={onValueChange}
      />
      {value === PERSON_SELECT_NOT_LISTED && (
        <p className='text-sm text-ink-body'>{m.manager_question_not_listed_note()}</p>
      )}
    </div>
  );
}
